<form [formGroup]="form">
    <h3 mat-dialog-title>
        Delete {{ data.paymentGroups.length > 1 ? data.paymentGroups.length : data.paymentGroups[0].gross | legfiCurrency:'USD':'symbol':'.2' }}
        Payment{{ data.paymentGroups.length > 1 ? 's' : '' }}?</h3>

    <mat-dialog-content class="small-content">
        <div class="form-group">
            <label>Reason for deletion:</label>
            <input class="form-control" formControlName="reason">
        </div>

        <div class="form-group d-flex justify-content-between">
            <label>Mark as Returned</label>
            <mat-slide-toggle
                formControlName="markReturned"
            ></mat-slide-toggle>
        </div>

        <div class="form-group d-flex justify-content-between" *ngIf="hasLinkedPayments">
            <label>Delete From Transactions</label>
            <mat-slide-toggle
                formControlName="deleteFromTransactions"
            ></mat-slide-toggle>
        </div>

    </mat-dialog-content>
    <mat-dialog-actions>
        <button type="button" class="btn btn-outline-secondary" mat-dialog-close>
            Cancel
        </button>
        <div>
            <button type="submit" (click)="closeAndConfirm()" class="btn btn-primary">
                Delete Payment
            </button>
        </div>
    </mat-dialog-actions>
</form>
